const trunkPrefixes = {
  noPrefix: [
    "+56",
    "+420",
    "+45",
    "+372",
    "+30",
    "+39",
    "+371",
    "+352",
    "+356",
    "+377",
    "+977",
    "+47",
    "+968",
    "+48",
    "+351",
    "+378",
    "+34",
    "+598",
    "+65",
  ],
  twoDigit: ["+52", "+976", "+36"],
};

function dialableNumber(number: string, prefix = "+61"): string {
  // based on https://en.wikipedia.org/wiki/Trunk_prefix

  // eslint-disable-next-line no-useless-escape
  number = number.replace(/[ \.\(\)-]/g, "");

  if (prefix === "+61" && ["13", "1300", "1800"].find((special) => number.startsWith(special))) {
    number = prefix + number;
  } else if (!number.startsWith("+")) {
    let cutoff = 1;
    if (trunkPrefixes.noPrefix.includes(prefix)) cutoff = 0;
    if (trunkPrefixes.twoDigit.includes(prefix)) cutoff = 2;
    // special case for China: drop 0 for landlines, keep 1 for mobiles
    if (prefix === "+86" && !number.startsWith("0")) cutoff = 0;
    number = prefix + number.substring(cutoff);
  }

  return number;
}

export default dialableNumber;
